import { render, staticRenderFns } from "./rptrekapkirimanae.vue?vue&type=template&id=0fb639a4"
import script from "./rptrekapkirimanae.vue?vue&type=script&lang=js"
export * from "./rptrekapkirimanae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports